export function canEditDriverMethodCollecting(method) {
  return Boolean(method) &&
    String(method.code ?? "").trim().toUpperCase() !== "CASH" &&
    String(method.name ?? "").trim().toLowerCase() !== "efectivo";
}

export async function updateDriverMethodCollectingUseCase(repository, driverId, method, paymentValue) {
  if (!canEditDriverMethodCollecting(method)) {
    return {
      success: false,
      data: null,
      error: "El método de cobro Efectivo no se puede editar.",
    };
  }
  if (typeof paymentValue !== "string" || Array.from(paymentValue).length > 50) {
    return {
      success: false,
      data: null,
      error: "La información de cobro debe tener como máximo 50 caracteres.",
    };
  }

  const result = await repository.update({
    id: method.id,
    drivers_id: driverId,
    payment_value: paymentValue === "" ? null : paymentValue,
  });
  if (!result.success) return result;
  return {
    ...result,
    data: { ...method, payment_value: result.data.payment_value },
  };
}
